var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBusinessMessagesBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1358_18128",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1358_18128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83317 16.6666C5.37484 16.6666 4.98248 16.5034 4.65609 16.177C4.3297 15.8506 4.1665 15.4583 4.1665 14.9999V7.29159L1.979 4.70825C1.90956 4.62492 1.86095 4.53811 1.83317 4.44784C1.80539 4.35756 1.7915 4.26381 1.7915 4.16659C1.7915 3.94436 1.86789 3.74992 2.02067 3.58325C2.17345 3.41659 2.37484 3.33325 2.62484 3.33325H16.6665C17.1248 3.33325 17.5172 3.49645 17.8436 3.82284C18.17 4.14922 18.3332 4.54159 18.3332 4.99992V14.9999C18.3332 15.4583 18.17 15.8506 17.8436 16.177C17.5172 16.5034 17.1248 16.6666 16.6665 16.6666H5.83317ZM11.4998 12.4999H14.1665C14.4026 12.4999 14.6005 12.4201 14.7603 12.2603C14.92 12.1006 14.9998 11.9027 14.9998 11.6666C14.9998 11.4305 14.92 11.2326 14.7603 11.0728C14.6005 10.9131 14.4026 10.8333 14.1665 10.8333H9.52067C9.14567 10.8333 8.88525 11.0034 8.73942 11.3437C8.59359 11.6839 8.65262 11.986 8.9165 12.2499L10.6665 13.9999C10.8193 14.1527 11.0137 14.2291 11.2498 14.2291C11.4859 14.2291 11.6804 14.1527 11.8332 13.9999C11.9859 13.8471 12.0623 13.6527 12.0623 13.4166C12.0623 13.1805 11.9859 12.986 11.8332 12.8333L11.4998 12.4999ZM10.9998 7.49992H8.33317C8.09706 7.49992 7.89914 7.57978 7.73942 7.7395C7.5797 7.89922 7.49984 8.09714 7.49984 8.33325C7.49984 8.56936 7.5797 8.76728 7.73942 8.927C7.89914 9.08672 8.09706 9.16658 8.33317 9.16658H12.979C13.354 9.16658 13.6144 8.99645 13.7603 8.65617C13.9061 8.31589 13.8471 8.01381 13.5832 7.74992L11.8332 5.99992C11.6804 5.84714 11.4859 5.77075 11.2498 5.77075C11.0137 5.77075 10.8193 5.84714 10.6665 5.99992C10.5137 6.1527 10.4373 6.34714 10.4373 6.58325C10.4373 6.81936 10.5137 7.01381 10.6665 7.16659L10.9998 7.49992Z",
    fill: "#1B4B86"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBusinessMessagesBlue);
export default __webpack_public_path__ + "static/media/icon_business_messages_blue.5e9f44656fb3c29750835b4e460cf9a8.svg";
export { ForwardRef as ReactComponent };